<template>
  <div class="flow">
    <Title :title="'流水记录'"></Title>
    <div class="wrapper">
      <div class="search-wrap" style="margin-top: 20px;">
        <template>
          <Select v-model="searchForm.type" style="width:150px" placeholder="事件类型">
            <Option v-for="item in type_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <template>
          <Select v-model="searchForm.is_income" style="width:150px" placeholder="收入类型">
            <Option v-for="item in is_income_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </template>
        <template>
          <input class="input-search" v-model="searchForm.relation_id" placeholder="请输入订单号"></input>
        </template>
        <template>
          <span>选择日期</span>
          <DatePicker type="date" placeholder="开始时间" v-model="searchForm.start_time_bak" style="width: 150px;"
            @on-change="handelDateChangeStart"></DatePicker>
          <span>至</span>
          <DatePicker type="date" placeholder="结束时间" v-model="searchForm.end_time_bak" style="width: 150px;"
            @on-change="handelDateChange"></DatePicker>
        </template>
        <!-- 操作按钮 -->
        <el-button style="margin-left:12px" type="warning" @click="onFormSearch">查询</el-button>
        <el-button type="warning" plain @click="onFormReset">重置</el-button>
        <el-button plain @click="exportData">导出</el-button>
      </div>
      <div class="table-wrapper">
        <Table :columns="columns" :data="list" :loading="listLoading" :row-class-name="rowClassName">
        </Table>
        <div style="padding: 10px 0px">
          <Page :total="total" :current="searchForm.page" show-sizer show-elevator show-total @on-change="changePage"
            @on-page-size-change="changePagesize"></Page>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from './components/title.vue'
import { Icon, Table, Page, Button, Select, Option, Input, DatePicker } from 'view-design'

import { getUserBalanceList } from '@/api/user'
import { getDate, formatDate } from '@/utils/date'

export default {
  name: '',
  components: {
    Title,
    Icon,
    Table,
    Page,
    Button,
    Select,
    Option,
    Input,
    DatePicker
  },
  data: function () {
    return {
      columns: [
        {
          title: '明细时间',
          key: 'create_time'
        },
        {
          title: '事件类型',
          key: 'type_str'
        },
        {
          title: '明细说明',
          key: 'mingxi_detail'
        },
        {
          title: '订单号',
          key: 'relation_id'
        },
        {
          title: '变动金额',
          key: 'amount'
        },
        {
          title: '变动后余额',
          key: 'after_amount'
        }
      ],
      listLoading: false,
      list: [],
      total: 0,
      searchForm: {
        page: 1,
        pagesize: 10,
        is_income: undefined,
        type: undefined,
        start_time_bak: undefined,
        end_time_bak: undefined,
        start_time: undefined,
        end_time: undefined,
        sort: '-id',
        relation_id: ''
      },
      is_income_list: [
        { value: '', label: '全部' },
        { value: '1', label: '收入' },
        { value: '2', label: '支出' }
      ],
      type_list: []
    }
  },
  created() {
    this.getList(true)
    this.$store.commit('nav/SET_ACTIVE_slideActive', 2)
  },
  methods: {
    getList(first = false) {
      this.listLoading = true
      if (first) this.searchForm.page = 1
      let searchForm = Object.assign({}, this.searchForm)
      searchForm.start_time = getDate(searchForm.start_time_bak)
      searchForm.end_time = getDate(searchForm.end_time_bak)
      if (searchForm.start_time) searchForm.start_time += ' 00:00:00'
      if (searchForm.end_time) searchForm.end_time += ' 23:59:59'
      delete searchForm.start_time_bak
      delete searchForm.end_time_bak
      getUserBalanceList(searchForm)
        .then(response => {
          this.listLoading = false
          if (response.code != 200) {
            this.$Message.error(response.msg)
            return
          }
          this.list = response.data.list
          this.total = response.data.total
          this.type_list = response.data.type_list
        })
        .catch(error => {
          this.listLoading = false
          console.log(error)
        })
    },
    rowClassName: function (row, index) {
      if (index % 2 === 0) {
        return 'bg-fa'
      } else {
        return 'bg-white'
      }
    },
    onFormSearch() {
      this.searchForm.page = 1
      this.getList(true)
    },
    onFormReset() {
      this.searchForm.relation_id=''
      this.searchForm.is_income=''
      this.searchForm.type=''
      this.searchForm.start_time = ''
      this.searchForm.end_time = ''
      this.searchForm.start_time_bak = ''
      this.searchForm.end_time_bak = ''
      this.onFormSearch()
    },
    changePage(value) {
      this.searchForm.page = value
      this.getList()
    },
    changePagesize(value) {
      this.searchForm.pagesize = value
      //如果处于第一页改变数量，则会触发changePage
      if (this.searchForm.page == 1) {
        this.getList()
      }
    },
    handelDateChange: function (time, type) {
      if (type == 'date') {
        if (this.searchForm.start_time_bak !== '') {
          if (this.compareTime(this.searchForm.start_time_bak, time)) {
            this.searchForm.end_time_bak = this.searchForm.start_time_bak
          }
        }
      }
    },
    handelDateChangeStart: function (time, type) {
      if (type == 'date') {
        if (this.searchForm.end_time_bak !== '') {
          if (this.compareTime(time, this.searchForm.end_time_bak)) {
            this.searchForm.start_time_bak = this.searchForm.end_time_bak
          }
        }
      }
    },
    compareTime: function (startTime, endTime) {
      var oDate1 = new Date(startTime)
      var oDate2 = new Date(endTime)
      if (oDate1.getTime() > oDate2.getTime()) {
        return true
      } else {
        return false
      }
    },
    exportData: function () {
      let searchForm = Object.assign({}, this.searchForm)
      searchForm.page = 1
      searchForm.pagesize = 50000
      searchForm.start_time = getDate(searchForm.start_time_bak)
      searchForm.end_time = getDate(searchForm.end_time_bak)
      if (searchForm.start_time) searchForm.start_time += ' 00:00:00'
      if (searchForm.end_time) searchForm.end_time += ' 23:59:59'
      delete searchForm.start_time_bak
      delete searchForm.end_time_bak
      getUserBalanceList(searchForm).then(async res => {
        const code = res.code
        const message = res.message
        if (code === 200) {
          await this.$alert(`当前数据下载中，请前往 导出中心 查看`, '导出数据提示', {
            showCancelButton: true,
            confirmButtonText: '前往导出列表',
            cancelButtonText: '取消',
            callback: action => {
              if(action === 'confirm'){
                this.$router.push({ path: "/pc/exportCenter/index" });
              }
              this.exportLoading = false
            }
          });
        } else {
          this.$Message.error(message)
        }
        // if (res.code != 200) {
        //   this.$message.error(res.message)
        //   return
        // }
        // let filename = "流水记录" + formatDate("yyMMddhhmmss")
        // let header = ['明细时间', '事件类型', '明细说明', '订单号', '变动类型', '变动后余额']
        // let data = res.data.list.map(x => {
        //   return [x.create_time, x.type_str, x.mingxi_detail, x.relation_id, x.amount, x.after_amount]
        // })
        // import('@/vendor/Export2Excel').then(excel => {
        //   excel.export_json_to_excel({
        //     header,
        //     data,
        //     filename
        //   })
        //   this.$message.success('导出成功')
        // })
      }).catch(error => {
        // this.$message.error(error.toString())
      })
    },
  }
}
</script>
<style lang='less' scoped>
.flow {
  @media(max-width: 1200px) {
    min-width: 1000px !important;
  }

  .wrapper {
    width: 100%;

    .tilte-text {
      font-size: 20px;
      color: #222222;
      text-align: left;
      font-weight: bold;
    }

    .table-wrapper {
      margin-top: 0.62rem;

      .show-excel {
        font-size: 14px;
        color: #ff4f76;
        cursor: pointer;
        display: inline-block;
        padding-right: 7px;

        :last-child {
          padding-right: 0px;
        }
      }

      .show-excel:last-child {
        padding-right: 0px;
      }
    }
  }
}

.input-search {
  width: 150px;
  height: 30px;
  height: 32px;
  line-height: 1.5;
  padding: 4px 7px;
  font-size: 14px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  color: #515a6e;
}

input::placeholder {
  font-size: 14px;
  color: #c5c8ce !important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/user/flowRecord.vue